import { IAutoMapper } from "../interfaces";

export const mapNotificationItems = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "NotificationItem")
    .forMember("specificDay", o => o.specificDay)
    .forMember(
      "notificationGroup",
      src =>
        automapper.mapMany(
          "default",
          "AlertNotification",
          src.notificationGroup
        )
    );
};

